module.exports = __webpack_public_path__ + "media/images/front/new2-e58f39c150b609c0dc44a288377cf43d.png";